import { render, staticRenderFns } from "./FaceVerifyPopu.vue?vue&type=template&id=7c079267&scoped=true"
import script from "./FaceVerifyPopu.vue?vue&type=script&lang=js"
export * from "./FaceVerifyPopu.vue?vue&type=script&lang=js"
import style0 from "./FaceVerifyPopu.vue?vue&type=style&index=0&id=7c079267&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c079267",
  null
  
)

export default component.exports